import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    showPagination: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    showCreate: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    showCriteria: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    showStatus: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    hasLink: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    showSelectRow: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data () {
    return {
      page: parseInt((this.$route.query || {}).page || 1),
      query: {},
      pagination: 20,
      selectedRows: [],
      dialogCreate: false
    }
  },
  computed: {
    showAll () {
      return Object.keys(this.showCriteria).length
    },
    totalPages () {
      return this.count > this.pagination ? Math.ceil(this.count / this.pagination) : 1
    }
  },
  created () {
    if (typeof this.getList === 'function') {
      this.getList()
    }

    // set initial visible headers list
    if (this.toggleHeaders) {
      this.headers = this.getHeaders()
    }
  },
  watch: {
    $route () {
      if (typeof this.getList === 'function') {
        this.getList()
      }
    },
    page () {
      this.setPage()
    },
    toggleHeaders () {
      /**
       * Watch toggleHeaders from store using mapState to set the visible headers list
       * @returns Array list headers
       */
      this.headers = this.getHeaders()
    }
  },
  methods: {
    getHeaders () {
      /**
       * Computes a list of visible headers (columns) to table
       * @returns Array list headers
       */
      if (!this.toggleHeaders) {
        return []
      }

      const toggleHeaders = this.toggleHeaders.map(c => c.id)
      const toggleHeadersToDisplay = this.toggleHeaders.filter(c => c.display).map(c => c.id)
      return this.baseHeaders.filter(c => !toggleHeaders.includes(c.value) || toggleHeadersToDisplay.includes(c.value))
    },
    setQuery () {
      this.$router.replace({name: this.$route.name, query: this.query}).catch(() => {})
    },
    setPage () {
      if (this.$route.query.page === this.page) {
        return false
      }
      this.$router.replace({name: this.$route.name, query: Object.assign({}, this.$route.query, {page: this.page})})
    },
    setSort (value) {
      if (this.$route.query.ordering === value) {
        value = `-${value}`
      }
      this.$router.replace({name: this.$route.name, query: Object.assign({}, this.$route.query, {ordering: value})}).catch(err => err)
    }
  }
}
